import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { useLazyGetArticleQuery } from '@api/baseApi';
import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import { isValidGuid } from '@components/utils';
import { Article } from '@api/types/Article';
import { setArticle } from '@pages/admin/article/store/slice';
import { ArticleForm } from '@pages/admin/article/article-form/ArticleForm';



export const ExistArticle = () => {
	const { t } = useTranslation([ 'admin', 'global']);
	const { id } = useParams<{ id: string }>();

	const dispatch = useDispatch();
	const dispatchSetArticle = (data: Article) => dispatch(setArticle(data));
	const [ runQuery, { data, isLoading, isFetching, isError }] = useLazyGetArticleQuery();


	useEffect(() => {
		if (id && isValidGuid(id)) {
			runQuery({ id: id });
		}
	}, [ id ]);

	useEffect(() => {
		if (data) {
			dispatchSetArticle(data);
		}
	}, [ data ]);


	if (!isValidGuid(id)) return (
		<p className='error-message'>{t('pages.article.badFormat')}</p>
	);


	if (isLoading || isFetching) return (
		<div className="app-page admin-page article-page">
			<p className='loading-message'><LoadingSpinner /></p>
		</div>
	);

	if (isError || !data) return (
		<div className="app-page admin-page article-page">
			<p className='error-message'>{t('loadingErrorMessage', { ns: 'global' })}</p>
		</div>
	);

	return (
		<div className="app-page admin-page article-page">
			<h1>{t('pages.article.headerExist')}</h1>
			<ArticleForm />
		</div>
	);
}